<app-masterheader></app-masterheader>

<div class="wrapper">
  <app-sidebar></app-sidebar>

  <div id="content">
    <div class="container-fluid py-4">
      <div class="row mb-3">
        <div class="col-12 text-center">
          <h4 class="mb-0 py-2 bg-dark text-white rounded">Annual Plan Of Operation</h4>
  
          <div class="mt-2 d-flex justify-content-center gap-2 flex-wrap">
            <a class="btn btn-sm btn-primary btn-outline-light" href="/assets/APO_DOCUMENTS/APO_User_Manual_v1_English.pdf"
              target="_blank">
              📘 English Manual
            </a>
            <a class="btn btn-sm btn-primary btn-outline-light" href="/assets/APO_DOCUMENTS/APO_User_Manual_v1_Odia.pdf"
              target="_blank">
              📗 ଓଡିଆ ମାନୁଆଲ୍ (Odia Manual)
            </a>
          </div>
        </div>
      </div>

      <!-- Floating Search Box -->
      <div class="card shadow-sm mb-4">
        <div class="card-body">
          <!-- Filter Section -->
          <div class="filter-section mb-4 p-3 bg-light rounded">
            <h5 class="filter-title mb-4 text-dark fw-semibold">
              <i class="fa fa-filter me-2 text-primary"></i>Filter Options
            </h5>
                <form [formGroup]="filterForm" class="row align-items-end g-3">

            <div class="col-md-3 col-sm-6">
              <label for="year" class="form-label text-muted small">Financial Year</label>
              <select class="form-control" formControlName="year">
                <option *ngFor="let year of financialYears" [value]="year.value">
                  {{ year.display }}
                </option>
              </select>
            </div>

            <div class="col-md-3 col-sm-6">
              <label  for="circle" class="form-label text-muted small">Circle</label>
              <select class="form-control"  (change)="getAllDivisionByCircleId(circleSelect.value)" 
              formControlName="circle" 
              #circleSelect
              >
                <option value="">All</option>
                <option *ngFor="let circle of circleList" [value]="circle.circleId">{{ circle.circleName }}</option>
              </select>
            </div>

            <div class="col-md-3 col-sm-6">
              <label  for="division" class="form-label text-muted small">Division</label>
              <select class="form-control"  (change)="getAllRangeByDivId(divisionSelect.value)" 
              formControlName="division" 
              #divisionSelect
            >
                <option value="">All</option>
                <option *ngFor="let division of divisionlist" [value]="division.divisionId">{{ division.divisionName }}</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6">
              <label  for="range" class="form-label text-muted small">Range</label>
              <select class="form-control" formControlName="range">
                <option value="">All</option>
                <option *ngFor="let range of rangelist" [value]="range.rangeId">{{ range.rangeName }}</option>
              </select>
            </div>

            <div class="col-md-3 col-sm-6">
              <label for="scheme" class="form-label text-muted small">Major Scheme</label>
              <select class="form-control" formControlName="scheme"  (change)="getAllSubSchemeDD($event.target.value)">
                  <option value="">All</option>
                                <option *ngFor="let scheme of schemeList" [value]="scheme.id">
                                  {{ scheme.name }}
                                </option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6">
              <label for="subscheme" class="form-label text-muted small">Scheme Details</label>
              <select class="form-control" formControlName="subscheme" (change)="getAllComponentDDByScheme($event)">
                <option value="">All</option>
                                <option *ngFor="let scheme of subSchemeList" [value]="scheme.id">
                                  {{ scheme.name }}
                                </option>
              </select>
            </div>

            <div class="col-md-3 col-sm-6">
              <label  for="component" class="form-label text-muted small">Component</label>
              <select class="form-control" formControlName="component">
                <option value="">All</option>
                <option *ngFor="let component of componentList" [value]="component.id">{{ component.name }}</option>
              </select>
            </div>

            <div class="col-md-3 col-sm-6">
              <label for="fromDate" class="form-label text-muted small">From Date</label>
              <input type="date" formControlName="fromDate" class="form-control"/>
            </div>
    
            <div class="col-md-3 col-sm-6">
              <label for="toDate" class="form-label text-muted small">To Date</label>
              <input type="date" formControlName="toDate" class="form-control"/>
            </div>
      
            <div class="col-md-3 d-flex align-items-end  gap-2  justify-content-start">
              <button type="button" class="btn btn-primary btn-sm me-2" (click)="applyFilter()">
                <i class="fa fa-search me-1"></i> Search
              </button>
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">
                <i class="fa fa-refresh me-1"></i> Reset
              </button>
            </div>

              </form>
          </div>
        </div>
      </div>

      <!-- List Table -->
      <div class="card shadow-sm">
        <div class="card-body table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
  <!-- Left: Heading -->
  <h6 class="text-secondary m-0">
    <i class="fa fa-list me-2"></i> List of Records
  </h6>

  <!-- Right: Button + Search Group -->
  <div class="d-flex align-items-center" style="gap: 10px; flex-wrap: nowrap;">
    <!-- <button
      class="btn btn-success"
      type="button"
      (click)="downloadApoListAsExcel()"
    >
      <i class="fa fa-file-excel-o me-1"></i> Excel
    </button> -->

    <div class="input-group input-group-sm" style="max-width: 300px;">
      <input
        type="text"
        class="form-control"
        placeholder="Search..."
        [(ngModel)]="searchText"
        (input)="filterTable()"
      />
      <span class="input-group-text bg-white">
        <i class="fa fa-search text-muted"></i>
      </span>
    </div>
  </div>
</div>

          
          <table class="table table-hover table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>Sl.No.</th>
                <th>Circle</th>
                <th>Division</th>
                <th>Range</th>
                <th>Major Scheme</th>
                 <th>Scheme Details</th>
                <th>Component</th>
                <th>Submission Date</th>
                <!-- <th>Submitted By</th> -->
                  <th>Approval Status</th>
                     <!-- <th>Division Approve</th>
                         <th>Circle Approve</th>
                                <th>State Approve</th> -->
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paginatedData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.circleName }}</td>
                <td>{{ item.divName }}</td>
                <td>{{ item.rangeName }}</td>
                <td>{{ item.schemeName }}</td>
                <td>{{ item.subSchemeName }}</td>
                <td>{{ item.componentName }}</td>
                <td>{{ item.creationDate | date:'mediumDate' }}</td>
                  <td >
                           <!-- Approval Status Badge Logic -->
                           <div *ngIf="item.dfoApprovalUserId == null ">
                          <!-- Before DFO acts -->
                          <span *ngIf="roleId == 11 || roleId == 12 || roleId == 10 || roleId == 1 "> ⏳ Provisional</span><br />
                          </div>
                          
                          <div *ngIf="item.dfoApprovalUserId != null">
                            <!-- After DFO action -->
                            <span *ngIf="roleId == 11" class="text-secondary"> {{ item.dfoApprovalId === 1 ? '✅ Approved' : '❌ Rejected'
                              }}</span><br />
                            <span *ngIf="roleId == 12">
                              {{ item.dfoApprovalId === 1 ? '✅ Approved By DFO' : '❌ Rejected By DFO' }}
                            </span>
                             <span *ngIf="roleId == 1 || roleId == 10">
                              ⏳ Provisional
                            </span>
                          </div>


                          <div *ngIf="item.circleApprovalUserId != null">
                            <span *ngIf="roleId == 10">{{ item.circleApprovalId === 1 ? '✅ Approved By Circle' : '❌ Rejected By Circle'
                              }}</span><br />
                          </div>
                          <div *ngIf="item.stateApprovalUserId != null">
                            <span *ngIf="roleId == 1">{{ item.stateApprovalId === 1 ? '✅ Approved By State' : '❌ Rejected By State'
                              }}</span><br />
                          </div>
                          </td>
                <!-- <td>{{ item.createdBy }}</td>  -->
                  <!-- <td>⏳ Provisional</td>  -->
                    <!-- <td>✅</td>  -->
                <td >
                  <button class="btn btn-sm btn-info custom-btn mb-1 mr-2" (click)="viewForm(item)">
                    <i class="fas fa-eye me-1"></i> View
                  </button>
                   
                    <ng-container *ngIf="roleId === 11 && !item.dfoApprovalUserId">
                      <button class="btn btn-success btn-sm" (click)="takeApoFormAction(item.formId, 'APPROVE')">✅ Approve</button>
                      <button class="btn btn-danger btn-sm" (click)="takeApoFormAction(item.formId, 'REJECT')">❌ Reject</button>
                    </ng-container>
                    <ng-container *ngIf="roleId === 10 && !item.circleApprovalUserId && item.dfoApprovalId === 1">
                      <button class="btn btn-success btn-sm" (click)="takeApoFormAction(item.formId, 'APPROVE')">✅ Approve</button>
                      <button class="btn btn-danger btn-sm" (click)="takeApoFormAction(item.formId, 'REJECT')">❌ Reject</button>
                    </ng-container>
                    <ng-container *ngIf="roleId === 1 && !item.stateApprovalUserId && item.circleApprovalId === 1">
                      <button class="btn btn-success btn-sm" (click)="takeApoFormAction(item.formId, 'APPROVE')">✅ Approve</button>
                      <button class="btn btn-danger btn-sm" (click)="takeApoFormAction(item.formId, 'REJECT')">❌ Reject</button>
                    </ng-container>
               

                  <!-- <button class="btn btn-sm btn-info custom-btn mb-1  mr-2"  *ngIf="roleId!==12" >
                    ✅ Approve
                  </button>
                   <button class="btn btn-sm btn-info custom-btn mb-1  mr-2"  *ngIf="roleId!==12" >
                   ❌ Reject
                  </button> -->
                  <!-- <button class="btn btn-sm btn-primary custom-btn" 
                  (click)="onClickExecution(item)">
                    <i class="fas fa-check-square me-1"></i> Execution
                  </button> -->
                </td>
              </tr>
              <tr *ngIf="paginatedData.length === 0">
                <td colspan="9" class="text-center">No records found.</td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <nav *ngIf="totalPages > 1" aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="changePage(currentPage - 1)">Previous</a>
              </li>

              <li class="page-item" *ngFor="let page of pagesArray" [class.active]="page === currentPage">
                <a class="page-link" (click)="changePage(page)">{{ page }}</a>
              </li>

              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="changePage(currentPage + 1)">Next</a>
              </li>
            </ul>
          </nav>

        </div>
      </div>

    </div>
  </div>
 <!-- Execution Modal -->
<div class="modal fade" id="executionModal" tabindex="-1" aria-labelledby="executionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="executionModalLabel">Execution Documents for {{ selectedItem?.schemeName }}</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs" id="executionTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="kml-tab" data-bs-toggle="tab" data-bs-target="#kml" type="button" role="tab" aria-controls="kml" aria-selected="true">KML File</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="images-tab" data-bs-toggle="tab" data-bs-target="#images" type="button" role="tab" aria-controls="images" aria-selected="false">Before/After Images</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="plan-tab" data-bs-toggle="tab" data-bs-target="#plan" type="button" role="tab" aria-controls="plan" aria-selected="false">Plan/Estimate</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="dpr-tab" data-bs-toggle="tab" data-bs-target="#dpr" type="button" role="tab" aria-controls="dpr" aria-selected="false">DPR</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="tender-tab" data-bs-toggle="tab" data-bs-target="#tender" type="button" role="tab" aria-controls="tender" aria-selected="false">Tender Document</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="workorder-tab" data-bs-toggle="tab" data-bs-target="#workorder" type="button" role="tab" aria-controls="workorder" aria-selected="false">Work Order</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="completion-tab" data-bs-toggle="tab" data-bs-target="#completion" type="button" role="tab" aria-controls="completion" aria-selected="false">Completion Certificate</button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content" id="executionTabContent">
          <div class="tab-pane fade show active" id="kml" role="tabpanel" aria-labelledby="kml-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="kmlFile" class="form-label">Upload KML File</label>
                <input type="file" class="form-control" id="kmlFile" formControlName="kmlFile" accept=".kml" (change)="onFileChange($event, 'kmlFile')">
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="images" role="tabpanel" aria-labelledby="images-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="beforeImage" class="form-label">Before Image</label>
                <input type="file" class="form-control" id="beforeImage" formControlName="beforeImage" accept="image/*" (change)="onFileChange($event, 'beforeImage')">
              </div>
              <div class="mb-3">
                <label for="afterImage" class="form-label">After Image</label>
                <input type="file" class="form-control" id="afterImage" formControlName="afterImage" accept="image/*" (change)="onFileChange($event, 'afterImage')">
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="plan" role="tabpanel" aria-labelledby="plan-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="planFile" class="form-label">Upload Plan/Estimate</label>
                <input type="file" class="form-control" id="planFile" formControlName="planFile" accept=".pdf" (change)="onFileChange($event, 'planFile')">
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="dpr" role="tabpanel" aria-labelledby="dpr-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="dprFile" class="form-label">Upload DPR</label>
                <input type="file" class="form-control" id="dprFile" formControlName="dprFile" accept=".pdf" (change)="onFileChange($event, 'dprFile')">
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="tender" role="tabpanel" aria-labelledby="tender-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="tenderFile" class="form-label">Upload Tender Document</label>
                <input type="file" class="form-control" id="tenderFile" formControlName="tenderFile" accept=".pdf" (change)="onFileChange($event, 'tenderFile')">
              </div>
            
            </form>
          </div>
          <div class="tab-pane fade" id="workorder" role="tabpanel" aria-labelledby="workorder-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="workOrderFile" class="form-label">Upload Work Order</label>
                <input type="file" class="form-control" id="workOrderFile" formControlName="workOrderFile" accept=".pdf" (change)="onFileChange($event, 'workOrderFile')">
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="completion" role="tabpanel" aria-labelledby="completion-tab">
            <form [formGroup]="executionForm">
              <div class="mb-3">
                <label for="completionFile" class="form-label">Upload Completion Certificate</label>
                <input type="file" class="form-control" id="completionFile" formControlName="completionFile" accept=".pdf" (change)="onFileChange($event, 'completionFile')">
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary custom-btn" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-sm btn-primary custom-btn" >Submit</button>
      </div>
    </div>
  </div>
</div>

  <div id="footer">
    <app-masterfooter></app-masterfooter>
  </div>
</div>
